export default {"src":"/_next/static/media/danger.e7969420.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};